import { Check, Copy, Mail } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Alert } from '@/components/ui/Alert'
import { Button } from '@/components/ui/Button'
import { formatDateTime } from '@/utils/format'
import type { Invitation } from '../types'

/** The invitation just sent, with the link to copy in case the email does not arrive. */
export function InvitationLink({ invitation, email }: { invitation: Invitation; email: string }) {
  const { t } = useTranslation('platform')
  const [copied, setCopied] = useState(false)
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(invitation.url)
      setCopied(true)
    } catch {
      setCopied(false)
    }
  }
  return (
    <Alert tone="success" title={t('Invitation sent to {{email}}', { email })}>
      <p className="flex items-center gap-1.5">
        <Mail className="size-3.5 shrink-0" aria-hidden="true" />
        {t('The link works once and expires on {{date}}. You can also share it yourself:', {
          date: formatDateTime(invitation.expiresAt),
        })}
      </p>
      <div className="mt-2 flex flex-col gap-2 sm:flex-row sm:items-center">
        <code className="min-w-0 flex-1 truncate rounded-control bg-surface px-2.5 py-1.5 text-xs text-ink ring-1 ring-line">
          {invitation.url}
        </code>
        <Button
          size="sm"
          variant="secondary"
          leftIcon={copied ? <Check /> : <Copy />}
          onClick={() => void copy()}
        >
          {copied ? t('Copied') : t('Copy link')}
        </Button>
      </div>
    </Alert>
  )
}
